<template>
  <input
      type="color"
      :value="value"
      @input="$emit('input', $event.target.value)"
      @keypress="$emit('keypress', $event)">
</template>

<script>
export default {
  name: 'BaseColorInput',
  props: {
    value: String,
  },
};
</script>

<style lang="scss" scoped>
input {
  $size: 2.25rem;
  background: transparent;
  border: none;
  height: $size;
  outline: none;
  width: $size;

  &::-webkit-color-swatch-wrapper {
    padding: 0;
  }

  &::-webkit-color-swatch {
    border-radius: 100%;
    border: none;
  }

  &::-moz-color-swatch {
    border-radius: 100%;
    border: none;
  }
}
</style>
